<template lang="html">
  <div class="inner-modal">
		<div class="head-modal spaced-row">
			<div>
				<div class="head-modal-title">
					Ajouter/Editer un conseiller
				</div>
				<div class="head-modal-emphase">
					Modifiez les informations d’un conseiller ou ajoutez en un.
				</div>
			</div>
			<div class="row">
				<div class="head-modal-label">ACTIVATION</div>
				<toggle-input :value="user.enabled" @change="user.enabled = !user.enabled" />
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('first_name')}">
							<label for="first_name">Prénom</label>
							<input v-validate="'required|alpha_spaces'" type="text" name="first_name" v-model="user.first_name">
						</div>
						<div v-if="errors.has('first_name')" class="error-message">{{ errors.first('first_name') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('last_name')}">
							<label for="last_name">Nom</label>
							<input v-validate="'required|alpha_spaces'" type="text" name="last_name" v-model="user.last_name">
						</div>
						<div v-if="errors.has('last_name')" class="error-message">{{ errors.first('last_name') }}</div>
					</div>
				</div>
				<!-- <div class="ctn-duo-input row"> -->
					<!-- <div class="left inner-duo"> -->
						<div class="ctn-input form-elem-container ctn-select ctn-label" v-selectUI :class="{error: errors.has('office')}">
							<label for="select">Mon cabinet</label>
							<custom-select
								v-model="user.office"
								:items="cabinetsNames"
								v-validate="'required'"
								data-vv-value-path="mutableValue"
    							data-vv-name="office"
    							:has-error="errors.has('office')"
							></custom-select>
						</div>
						<div v-if="errors.has('office')" class="error-message">{{ errors.first('office') }}</div>
					<!-- </div> -->
					<!-- <div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('siret')}">
							<label for="siret">ID Entreprise</label>
							<input v-validate="'required|length:14'" type="text" name="siret" v-model="user.siret">
						</div>
						<div v-if="errors.has('siret')" class="error-message">{{ errors.first('siret') }}</div>
					</div> -->
				<!-- </div> -->
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('address')}">
							<label for="address">Adresse du conseiller</label>
							<input v-validate="'required'" type="text" name="address" v-model="user.address">
						</div>
						<div v-if="errors.has('address')" class="error-message">{{ errors.first('address') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('zipcode')}">
							<label for="postalcode">Code postal</label>
							<input v-validate="'required|length:5'" type="text" name="zipcode" v-model="user.zipcode">
						</div>
						<div v-if="errors.has('zipcode')" class="error-message">{{ errors.first('zipcode') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('city')}">
							<label for="city">Ville</label>
							<input v-validate="'required|alpha_spaces'" type="text" name="city" v-model="user.city">
						</div>
						<div v-if="errors.has('city')" class="error-message">{{ errors.first('city') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input form-elem-container ctn-select ctn-label" v-selectUI :class="{error: errors.has('country')}">
							<label for="select">Pays</label>
							<custom-select
								v-model="user.country"
								:items="countries"
								v-validate="'required'"
								data-vv-value-path="mutableValue"
    							data-vv-name="country"
    							:has-error="errors.has('country')"
							></custom-select>
						</div>
						<div v-if="errors.has('country')" class="error-message">{{ errors.first('country') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('phone')}">
							<label for="phone">Téléphone</label>
							<input v-validate="'required|numeric|length:10'" type="phone" name="phone" v-model="user.phone">
						</div>
						<div v-if="errors.has('phone')" class="error-message">{{ errors.first('phone') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email')}">
							<label for="email">Adresse mail</label>
							<input v-validate="'required|email'" type="email" name="email" v-model="user.email">
						</div>
						<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
					</div>
				</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('password')}">
					<label for="password">Mot de passe</label>
					<input type="password" name="password" v-model="user.password">
				</div>
				<div v-if="errors.has('password')" class="error-message">{{ errors.first('password') }}</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="validateBeforeSubmit">Enregistrer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import countries from '@/fixtures/countries'

// const DEFAULT_USER = {
// 	first_name: "Raymond",
// 	last_name: "Tabernoux",
// 	password: "123456",
// 	phone: "0123457890",
// 	email: "r.tabernoux@test.fr",
// 	address: "5 rue des cocotiers",
// 	zipcode: "99999",
// 	city: "Paris",
// 	office: null,
// 	siret: "12345678912345",
// 	country: null,
// 	enabled: 1,
// 	// role: 'CGP',
// 	// centerOfInterests: []
// }

export default {
	name: 'AddConseiller',
	props: ['data'],
	data () {
		return {
			cabinets: [],
			countries,
			user: {
				first_name: "",
				last_name: "",
				password: "",
				phone: "",
				email: "",
				address: "",
				zipcode: "",
				city: "",
				office: null,
				// siret: "",
				country: null,
				enabled: true,
				role: 'CGP',
				centerOfInterests: []
			}
		}
	},
	beforeMount () {
		this.$store.dispatch('getCabinets')
		.then(() => {
			this.cabinets = this.$store.getters['cabinets']
		})
		if (this.data) {
      this.user = this.data
		} else {
			// this.user = {...DEFAULT_USER}
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		submit () {
			const foundCabinet = this.cabinets.find(cabinet => cabinet.name === this.user.office)
			// this.$store.dispatch('addConseiller', {...this.user, office: foundCabinet ? foundCabinet.id : 1})
			this.$store.commit('LOADER_IN')
			this.$store.dispatch('addConseiller', {...this.user, office: foundCabinet.id})
			.then(() => {
				this.$store.commit('LOADER_OUT')
				this.close()
				// this.user = DEFAULT_USER
			})
			.catch(() => {
				this.$store.commit('LOADER_OUT')
				this.close()
				// this.user = DEFAULT_USER
			})
		},
		validateBeforeSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.submit()
					return
				}
			});
		},
		// onSelectCabinet (cabinetName) {}
	},
	computed: {
		cabinetsNames () {
			return this.cabinets ? this.cabinets.map(cabinet => cabinet.name) : []
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConseillerModal.vue?119dbb73